'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _ExistingAccount = require('./ExistingAccount.scss');

var _ExistingAccount2 = _interopRequireDefault(_ExistingAccount);

var _components = require('../../components');

var _BaseButton = require('../../components/BaseButton/BaseButton');

var _Subscription = require('../../helpers/Subscription');

var _Product = require('../../helpers/Product');

var _DefaultString = require('../../helpers/DefaultString');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExistingAccount = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { pushState: _reactRouterRedux.push, editEmail: _auth.editEmail }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ExistingAccount, _Component);

  function ExistingAccount() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExistingAccount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExistingAccount.__proto__ || (0, _getPrototypeOf2.default)(ExistingAccount)).call.apply(_ref, [this].concat(args))), _this), _this.getEmailTextComponent = function () {
      var _this$props$auth = _this.props.auth,
          email = _this$props$auth.email,
          productName = _this$props$auth.productName,
          clientId = _this$props$auth.clientId;

      var component = _react2.default.createElement(
        'div',
        { className: _ExistingAccount2.default.text },
        _react2.default.createElement(
          'div',
          { className: _ExistingAccount2.default.userEmail },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ExistingAccountEmail),
          email
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.EmailAlreadyAssociated)
        )
      );

      if ((0, _Product.isKaraokeTsm)(productName, clientId)) {
        component = _react2.default.createElement(
          'div',
          { className: _ExistingAccount2.default.text },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ExistingAccountEmail),
          _react2.default.createElement(
            'span',
            { className: _ExistingAccount2.default.userEmail },
            email
          ),
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.EmailAlreadyAssociated)
        );
      }
      return component;
    }, _this.getProductsComponent = function () {
      var _this$props$auth2 = _this.props.auth,
          productName = _this$props$auth2.productName,
          clientId = _this$props$auth2.clientId;

      return (0, _keys2.default)(_Product.PRODUCT_NAMES).map(function (key) {
        return _react2.default.createElement(
          'div',
          { key: _Product.PRODUCT_NAMES[key], className: _ExistingAccount2.default.productImageWrapper },
          _react2.default.createElement('img', {
            src: (0, _Subscription.getSubscriptionImage)(_Product.PRODUCT_NAMES[key], (0, _Product.isKaraokeTsm)(productName, clientId) || (0, _Product.isKaraoke)(productName, clientId) ? "_dark" : ""),
            alt: _Product.PRODUCT_NAMES[key],
            key: _Product.PRODUCT_NAMES[key]
          })
        );
      });
    }, _this.goToSignUp = function () {
      if (_this.props.auth.email) {
        _this.props.editEmail('');
      } else {
        _this.navigateToSignUp(_this.props);
      }
    }, _this.navigateToSignUp = function (props) {
      props.pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.SignUpEmail));
    }, _this.login = function () {
      _this.props.pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.LoginOptions));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExistingAccount, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.email && !nextProps.auth.email) {
        this.navigateToSignUp(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var emailTextComponent = this.getEmailTextComponent();
      var productsComponent = this.getProductsComponent();
      return _react2.default.createElement(
        'div',
        { className: _ExistingAccount2.default.existingAccountContent },
        _react2.default.createElement(
          'div',
          { className: _ExistingAccount2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ExistingAccount)
        ),
        emailTextComponent,
        _react2.default.createElement(
          'div',
          { className: _ExistingAccount2.default.container },
          productsComponent
        ),
        _react2.default.createElement(
          'div',
          { className: _ExistingAccount2.default.text + ' ' + _ExistingAccount2.default.existingText },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.PleaseLoginWithExistingAccount)
        ),
        _react2.default.createElement(_components.BaseButton, {
          className: _ExistingAccount2.default.loginButton,
          onClick: this.login,
          buttonString: _DefaultString.translations.Login,
          theme: _BaseButton.ButtonTheme.CallToAction
        }),
        _react2.default.createElement(_components.BaseButton, {
          className: _ExistingAccount2.default.anotherEmail,
          onClick: this.goToSignUp,
          buttonString: _DefaultString.translations.UseAnotherEmail,
          theme: _BaseButton.ButtonTheme.Secondary
        })
      );
    }
  }]);
  return ExistingAccount;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  editEmail: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(ExistingAccount);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ExistingAccount/ExistingAccount.js
// module id = 2006
// module chunks = 0